<template>
  <div>
    <div class="homePage" style="padding-top: 10px;">
      <!-- <ul class="navigationList">
        <li class="navigationItem" v-for="(i, x) in navigationList" :key="x" @click="navigationClick(i)">
          <p class="wordColor">{{ i.label }}</p>
          <p v-if="i.value === areaCode" class="navigationAvtive bgColor"></p>
        </li>
      </ul> -->
      <!-- 头条 -->
      <div class="item-box">
        <div class="headline">
          <a :href="$common.newsDetailsToLinkFn(dataObj.titleObj)" :target="target" class="headline-title "
            :title="dataObj.titleObj.title">
            <p style="font-size: 26px;" class="wordColor"> {{ dataObj.titleObj.title }}</p>
            <p style="font-size: 14px;color: #908989;padding-top: 5px;">{{ dataObj.titleObj.summary }}</p>
          </a>
        </div>
      </div>
      <div class="item-box">
        <!-- 轮播图 -->
        <div style="width: 40%;" class="imgNew">
          <el-carousel :interval="3000" indicator-position="outside" v-if="dataObj.tpxw && dataObj.tpxw.length">
            <el-carousel-item v-for="(item, index) in dataObj.tpxw" :key="index" class="carousel" :title="item.title">
              <a :href="$common.newsDetailsToLinkFn(item)" :target="target">
                <img v-if="item.extend && item.extend.coverList" :src="item.extend.coverList[0].url" :alt="item.title"
                  class="carousel-img" />
                <div class="carousel-title">
                  <div class="carousel-title-item">{{ item.title }}</div>
                </div>
              </a>
            </el-carousel-item>
          </el-carousel>
          <el-empty style="height: 100%" v-else description="暂无数据" />
        </div>
        <div style="width: calc(60% - 10px);" class="item-m">
          <ul class="hd">
            <a v-for="(i, x) in list1" :key="x" v-on:mouseenter="value1 = i.value" :title="i.label" class="hd-item"
              :class="value1 === i.value ? 'wordColor' : 'defaultColor'"
              :href="'/newList?navCode=' + i.navCode + '&navName=' + i.label" :target="target">
              <span style="padding: 0 5px;"> {{ i.label }}</span>
              <p class="hd_item_borderBottom bgColor" v-if="value1 === i.value"></p>
            </a>
          </ul>
          <div class="item-list">
            <ul class="bd" v-show="value1 === '1'">
              <li v-for="(i, x) in dataObj.zhxw || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul class="bd" v-show="value1 === '2'">
              <li v-for="(i, x) in dataObj.zxyw || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul class="bd" v-show="value1 === '3'">
              <li v-for="(i, x) in dataObj.tzgg || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul class="bd" v-show="value1 === '4'">
              <li v-for="(i, x) in dataObj.rsrm || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul class="bd" v-show="value1 === '5'">
              <li v-for="(i, x) in dataObj.bgjh || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 滚动播报 -->
      <div class="item-box" v-if="false">
        <div class="broadcastBox">
          <div class="broadcast-left borderColor wordColor">
            <p>滚动</p>
            <p>播报</p>
          </div>
          <p class="broadcast-vertical bgColor"></p>
          <div class="broadcast-right">
            <!-- <i style="font-size: 18px;" class="iconfont icon-laba wordColor"></i> -->
            <vue-seamless-scroll :data="dataObj.tzgg" :class-option="classOption"
              class="seamless-warp item-content-value">
              <ul class="broadcast-list" v-if="dataObj.tzgg.length">
                <li class="broadcast-item wordColor" v-for="(i, x) in dataObj.tzgg" :key="x">
                  <i style="font-size: 18px;margin-right: 5px;" class="iconfont icon-dian wordColor"></i>
                  <a class="hoverColor" :href="$common.newsDetailsToLinkFn(i)" :target="target"><span
                      class="wordColor">{{ i.title }}</span></a>
                </li>
              </ul>
              <p v-else>暂无公告</p>
            </vue-seamless-scroll>

          </div>
        </div>
      </div>
      <!-- 政协全会、常委会会议、主席会议 -->
      <div class="item-box">
        <a style="width: calc(33.3% - 6px);" href="/newList?navCode=22&navName=政协全会" :target="target">
          <img style="width: 100%;display: block;" :src="global.imageUrl + '/bannerMeeting_2.png'" alt="" />
        </a>
        <a style="width: calc(33.3% - 6px);" href="/newList?navCode=23&navName=常委会会议" :target="target">
          <img style="width: 100%;display: block;" :src="global.imageUrl + '/bannerMeeting_1.png'" alt="" />
        </a>
        <a style="width: calc(33.3% - 6px);" href="/newList?navCode=24&navName=主席会议" :target="target">
          <img style="width: 100%;display: block;" :src="global.imageUrl + '/bannerMeeting_3.png'" alt="" />
        </a>
      </div>
      <div class="item-box">
        <a href="https://www.hnzx.gov.cn/dhtxmtp" target="_blank">
          <img style="width: 100%;display: block;" :src="global.imageUrl + '/homeBanner1.png'" alt="" />
        </a>
      </div>
      <div class="item-box">
        <div style="width: calc(26% - 7px);background: #fff;">
          <p class="itemHeaderOne bgColor">
            <span class="item-hd-text">政协{{ global.title }}委员会</span>
          </p>
          <div class="zrzc-content">
            <div class="personnel">
              <span class="personnel-l">
                <i class="iconfont icon-shuxian wordColor"></i>主席：</span>
              <div class="personnel-list">
                <span class="personnel-n">
                  {{ leaderObj.zhuxi.name || '暂无' }}
                </span>
              </div>
            </div>
            <div class="personnel">
              <span class="personnel-l">
                <i class="iconfont icon-shuxian wordColor"></i>副主席：</span>
              <div class="personnel-list">
                <span class="personnel-n" v-for="(i, x) in leaderObj.fuzhuxi" :key="x" v-if="leaderObj.fuzhuxi.length">
                  {{ i.name }}
                </span>
                <span class="personnel-n" v-else>暂无</span>
              </div>
            </div>
            <div class="personnel">
              <span class="personnel-l">
                <i class="iconfont icon-shuxian wordColor"></i>秘书长：</span>
              <div class="personnel-list">
                <span class="personnel-n">
                  {{ leaderObj.mishuzhang.name || '暂无' }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div style="width: calc(37% - 7px);" class="item-m">
          <ul class="hd">
            <a v-for="(i, x) in active1List" :key="x" v-on:mouseenter="active1 = i.value" :title="i.label"
              class="hd-item" :class="active1 === i.value ? ' wordColor' : 'defaultColor'"
              :href="'/newList?navCode=' + i.navCode + '&navName=' + i.label" :target="target">
              <span style="padding: 0 5px;"> {{ i.label }}</span>
              <p class="hd_item_borderBottom bgColor" v-if="active1 === i.value"></p>
            </a>
          </ul>
          <div class="item-list">
            <ul style="min-height: 240px;" class="bd" v-show="active1 === '1'">
              <li v-for="(i, x) in dataObj.jgjs || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul style="min-height: 240px;" class="bd" v-show="active1 === '2'">
              <li v-for="(i, x) in dataObj.dptt || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div style="width: calc(37% - 7px);" class="item-m">
          <ul class="hd">
            <a v-for="(i, x) in active2List" :key="x" v-on:mouseenter="active2 = i.value" :title="i.label"
              class="hd-item" :class="active2 === i.value ? ' wordColor' : 'defaultColor'"
              :href="'/newList?navCode=' + i.navCode + '&navName=' + i.label" :target="target">
              <span style="padding: 0 5px;"> {{ i.label }}</span>
              <p class="hd_item_borderBottom bgColor" v-if="active2 === i.value"></p>
            </a>
          </ul>
          <div class="item-list">
            <ul style="min-height: 240px;" class="bd" v-show="active2 === '1'">
              <li v-for="(i, x) in dataObj.zxlt || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul style="min-height: 240px;" class="bd" v-show="active2 === '2'">
              <li v-for="(i, x) in dataObj.zthc || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 委员读书横幅 -->
      <div class="item-box">
        <a href="https://www.rmzxw.com.cn/zt/wydsh/index.shtml" target="_blank">
          <img style="width: 100%;display: block;" :src="global.imageUrl + '/homeBanner2.png'" alt="" />
        </a>
      </div>
      <div class="item-box">
        <!-- 轮播图 -->
        <div style="width: 40%;">
          <a class="hyshgzClass" :href="$common.newsDetailsToLinkFn(dataObj.imgList1[0])" :target="target"
            v-if="dataObj.imgList1.length && dataObj.imgList1[0].extend.coverList.length">
            <img style="width:100%;height: 100%;object-fit: cover;" :src="dataObj.imgList1[0].extend.coverList[0].url"
              alt="">
            <p class="hyshgz_title">{{ dataObj.imgList1[0].title }}</p>
          </a>
          <el-empty style="height: 100%" v-else description="暂无数据" />
        </div>
        <div style="width: calc(60% - 10px);" class="item-m">
          <ul class="hd">
            <a v-for="(i, x) in list2" :key="x" v-on:mouseenter="value2 = i.value" :title="i.label" class="hd-item"
              :class="value2 === i.value ? 'wordColor' : 'defaultColor'"
              :href="'/newList?navCode=' + i.navCode + '&navName=' + i.label" :target="target">
              <span style="padding: 0 5px;"> {{ i.label }}</span>
              <p class="hd_item_borderBottom bgColor" v-if="value2 === i.value"></p>
            </a>
          </ul>
          <div class="item-list">
            <ul class="bd" v-show="value2 === '1'">
              <li v-for="(i, x) in dataObj.wylz || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul class="bd" v-show="value2 === '2'">
              <li v-for="(i, x) in dataObj.taxx || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul class="bd" v-show="value2 === '3'">
              <li v-for="(i, x) in dataObj.sqmy || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
            <ul class="bd" v-show="value2 === '4'">
              <li v-for="(i, x) in dataObj.hdhy || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="item-box">
        <!-- 政协党建 -->
        <div class="item-m" style="width: calc(50% - 5px);">
          <ul class="hd" style="margin-bottom: 10px;">
            <a v-for="(i, x) in list3" :key="x" v-on:mouseenter="value3 = i.value" :title="i.label" class="hd-item"
              :class="value3 === i.value ? 'wordColor' : 'defaultColor'"
              :href="'/newList?navCode=' + i.navCode + '&navName=' + i.label" :target="target">
              <span style="padding: 0 5px;"> {{ i.label }}</span>
              <p class="hd_item_borderBottom bgColor" v-if="value3 === i.value"></p>
            </a>
          </ul>
          <div v-show="value3 === '1'">
            <a class="hyshgzClass" :href="$common.newsDetailsToLinkFn(dataObj.zxdjImg[0])" :target="target"
              v-if="dataObj.zxdjImg.length && dataObj.zxdjImg[0].extend.coverList.length">
              <img style="width:100%;height: 100%;object-fit: cover;" :src="dataObj.zxdjImg[0].extend.coverList[0].url"
                alt="">
              <p class="hyshgz_title">{{ dataObj.zxdjImg[0].title }}</p>
            </a>
            <div class="item-list" style="min-height: 200px;">
              <ul class="bd">
                <li v-for="(i, x) in dataObj.zxdj || []" :key="x">
                  <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                    <span :title="i.title" class="bd-item-title hoverColor">
                      <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                    <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-show="value3 === '2'">
            <a class="hyshgzClass" :href="$common.newsDetailsToLinkFn(dataObj.zxgzImg[0])" :target="target"
              v-if="dataObj.zxgzImg.length && dataObj.zxgzImg[0].extend.coverList.length">
              <img style="width:100%;height: 100%;object-fit: cover;" :src="dataObj.zxgzImg[0].extend.coverList[0].url"
                alt="">
              <p class="hyshgz_title">{{ dataObj.zxgzImg[0].title }}</p>
            </a>
            <div class="item-list" style="min-height: 200px;">
              <ul class="bd">
                <li v-for="(i, x) in dataObj.zxgz || []" :key="x">
                  <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                    <span :title="i.title" class="bd-item-title hoverColor">
                      <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                    <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 视察调研 -->
        <div class="item-m" style="width: calc(50% - 5px);">
          <ul class="hd" style="margin-bottom: 10px;">
            <a v-for="(i, x) in list4" :key="x" v-on:mouseenter="value4 = i.value" :title="i.label" class="hd-item"
              :class="value4 === i.value ? 'wordColor' : 'defaultColor'"
              :href="'/newList?navCode=' + i.navCode + '&navName=' + i.label" :target="target">
              <span style="padding: 0 5px;"> {{ i.label }}</span>
              <p class="hd_item_borderBottom bgColor" v-if="value4 === i.value"></p>
            </a>
          </ul>
          <div v-show="value4 === '1'">

            <a class="hyshgzClass" :href="$common.newsDetailsToLinkFn(dataObj.scdyImg[0])" :target="target"
              v-if="dataObj.scdyImg.length && dataObj.scdyImg[0].extend.coverList.length">
              <img style="width:100%;height: 100%;object-fit: cover;" :src="dataObj.scdyImg[0].extend.coverList[0].url"
                alt="">
              <p class="hyshgz_title">{{ dataObj.scdyImg[0].title }}</p>
            </a>
            <div class="item-list" style="min-height: 200px;">
              <ul class="bd">
                <li v-for="(i, x) in dataObj.scdy || []" :key="x">
                  <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                    <span :title="i.title" class="bd-item-title hoverColor">
                      <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                    <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-show="value4 === '2'">
            <a class="hyshgzClass" :href="$common.newsDetailsToLinkFn(dataObj.hdhyImg[0])" :target="target"
              v-if="dataObj.hdhyImg.length && dataObj.hdhyImg[0].extend.coverList.length">
              <img style="width:100%;height: 100%;object-fit: cover;" :src="dataObj.hdhyImg[0].extend.coverList[0].url"
                alt="">
              <p class="hyshgz_title">{{ dataObj.hdhyImg[0].title }}</p>
            </a>
            <div class="item-list" style="min-height: 200px;">
              <ul class="bd">
                <li v-for="(i, x) in dataObj.hdhy || []" :key="x">
                  <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                    <span :title="i.title" class="bd-item-title hoverColor">
                      <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                    <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="item-box">
        <a :href="global.serviceUrl" target="_blank">
          <img style="width: 100%;display: block;" :src="global.imageUrl + '/homeBanner3.png'" alt="" />
        </a>
      </div>
      <div class="item-box">
        <div class="item-m" style="width: calc(50% - 5px);">
          <div class="item-hd ">
            <a class=" wordColor itemLabel" :target="target" href="/newList?navCode=cppccwz-015&navName=学习培训">
              <p class="item-hd-text wordColor">学习培训</p>
              <p class="item-hd-text-btm bgColor"></p>
            </a>
          </div>
          <div class="item-list">
            <ul class="bd">
              <li v-for="(i, x) in dataObj.xxpx || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
          </div>

          <!-- <div class="hdjl-content">
            <a :class="i.url ? '' : 'pointerEvents'" class="hdjl-content-item"
              v-for="(i, x) in $commonData.data.hdjlList" :key="x" :href="i.url" :target="target">
              <i style="font-size: 30px" class="iconfont wordColor" :class="i.icon"></i>
              <p class="hdjl-i-t">{{ i.label }}</p>
            </a>
          </div> -->
        </div>
        <div class="item-m" style="width: calc(50% - 5px);">
          <div class="item-hd ">
            <div class=" wordColor itemLabel" :target="target" href="/newList?navCode=zx_wyjt&navName=委员讲堂">
              <p class="item-hd-text wordColor">委员讲堂</p>
              <p class="item-hd-text-btm bgColor"></p>
            </div>
          </div>
          <a v-if="dataObj.xqzxImg.length && dataObj.xqzxImg[0].extend.coverList.length"
            :href="$common.newsDetailsToLinkFn(dataObj.xqzxImg[0])" :target="target" class="jgdj_left"
            style="width: 100%;">
            <img style="width: 250px;height: 150px;" class="jgdj_left_img"
              :src="dataObj.xqzxImg[0].extend.coverList[0].url" alt="">
            <div class="jgdj_left_box" style="width: calc(100% - 260px);">
              <p class="jgdj_left_title wordColor">{{ dataObj.xqzxImg[0].title }}</p>
              <p class="jgdj_left_content">
                {{ dataObj.xqzxImg[0].summary }}
              </p>
            </div>
          </a>
          <div class="item-list">
            <ul class="bd">
              <li v-for="(i, x) in dataObj.xqzx || []" :key="x">
                <a class="bd-item" :href="$common.newsDetailsToLinkFn(i)" :target="target">
                  <span :title="i.title" class="bd-item-title hoverColor">
                    <i style="font-size: 16px" class="iconfont icon-dian wordColor"></i>{{ i.title }}</span>
                  <span class="bd-item-date">【{{ $common.getDateStr(i.publishTime) }}】</span>
                </a>
              </li>
            </ul>
          </div>
          <div style="padding-top: 10px;">
            <a style="width: 100%;display: block;" href="http://www.cppcc.gov.cn/zxww/newcppcc/wyjt/index.shtml"
              target="_blank">
              <img style="width: 100%;display: block;" :src="global.imageUrl + '/xxpx.png'" alt="" />
            </a>

          </div>
        </div>

      </div>
      <!-- 视频-->
      <div class="item-box" v-if="false">
        <div class="item-m videoBox" style="width: 100%;">
          <div class="item-hd ">
            <a class=" wordColor itemLabel" :target="target" href="/newList?navCode=video&navName=视频">
              <p class="item-hd-text wordColor">视频</p>
              <p class="item-hd-text-btm bgColor"></p>
            </a>
          </div>
          <div class=" videoBox-c" style="padding: 10px 0;">
            <el-carousel :cardScale="0.75" type="card" arrow="always" :interval="3000" indicator-position="outside"
              v-if="dataObj.videoList.length">
              <el-carousel-item v-for="(item, index) in dataObj.videoList" :key="index" class="carousel"
                :title="item.title">
                <a :href="$common.newsDetailsToLinkFn(item)" :target="target">
                  <img v-if="item.extend && item.extend.coverList" :src="item.extend.coverList[0].url" :alt="item.title"
                    class="carousel-img" />
                  <div class="carousel-title">
                    <div class="carousel-title-item">{{ item.title }}</div>
                  </div>

                </a>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <!-- 矩阵-->
      <div class="item-box" v-if="false">
        <div class="item-m matrixBox" style="width: 100%;">
          <div class="matrixBox-c" style="padding: 10px 0;">
            <el-carousel height="200px" :interval="3000" :autoplay="false" indicator-position="none" arrow="always">
              <el-carousel-item v-for="(i, x) in matrixList" :key="x">
                <ul class="matrixBox_ul">
                  <a :href="j.url" :target="target" class="matrixBox_li" v-for="(j, p) in i" :key="p">
                    <i style="font-size: 120px;color: #fff;" class="iconfont" :class="j.icon"></i>
                    <span style="font-size: 20px;color: #fff;    margin-top: 10px;">{{ j.label }}</span>
                  </a>
                </ul>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <!--书籍推荐 -->
      <div class="item-box" v-if="false">
        <div class="item-m" style="width: 100%;">
          <div class="item-hd ">
            <a class=" wordColor itemLabel" :target="target" href="/newList?navCode=book&navName=书籍推荐">
              <p class="item-hd-text wordColor">书籍推荐</p>
              <p class="item-hd-text-btm bgColor"></p>
            </a>
          </div>
          <div class="bookListBox">
            <a v-for="(item, index) in dataObj.bookList" :key="index" class="book_item"
              :href="$common.newsDetailsToLinkFn(item)" :target="target">
              <img v-if="item.extend && item.extend.coverList" :src="item.extend.coverList[0].url"
                class="carousel-img" />
              <p :title="item.title" class="book_item_title hoverColor"> {{ item.title }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- 悬浮窗口 -->
    <!-- <div class="suspension1">
      <img style="width: 100%;display: block;" :src="global.imageUrl + '/suspension1.png'" alt="">
      <p class="wordColor" style="letter-spacing: 0.1em;">官方微信公众号</p>
    </div> -->
    <div class="suspension2">
      <a :href="$commonData.data.gzcyHttp" target="_blank">
        <img style="width: 100%;display: block;" :src="global.imageUrl + '/suspension2.png'" alt="">
      </a>
    </div>
    <!-- <div class="suspension3">
      <img style="width: 100%;display: block;" :src="global.imageUrl + '/suspension3.png'" alt="">
      <p class="wordColor" style="letter-spacing: 0.1em;">征集通道</p>
      <p class="wordColor" style="letter-spacing: 0.1em;">（手机端）</p>
    </div> -->
    <footer-box :dictionarys="dictionarys" ref="footerBox"></footer-box>
  </div>

</template>
<script>
import { login, articlePage, dictionarySearch, friendlyLinksSearch, representativeSearch } from '@/api/api.js'
import global from '@/assets/js/global.js'
import footerBox from '@/views/index/footer'
export default {
  name: 'HomePage',
  data() {
    return {
      leaderObj: {
        zhuxi: {},
        fuzhuxi: [],
        dangzuchengyuan: [],
        mishuzhang: {}
      },
      matrixList: [
        [{
          label: '人民建议征集',
          icon: 'icon-tiaochawenjuan',
          url: '/rmyjzj'
        }, {
          label: '信息系统',
          icon: 'icon-pingtaiguanli',
          url: '/xxxt'
        }, {
          label: '微信矩阵',
          icon: 'icon-weixin1',
          url: '/wxjz'
        }],
        [{
          label: '中国志愿服务网',
          icon: 'icon-yijianfankui',
          url: 'https://chinavolunteer.mca.gov.cn/site/home'
        }, {
          label: '中国社会工作网',
          icon: 'icon-pingtai',
          url: 'https://shgz.mca.gov.cn/SWMS/LEAP/swmss/index.html#/web'
        }],
      ],
      classOption: {
        limitMoveNum: 2,
        direction: 2,
      },
      dictionarys: [],
      global: global,
      target: '_self',
      repName: '',
      value1: '1',
      list1: [
        {
          label: '综合新闻',
          value: '1',
          navCode: 'cppccwz-016'
        }, {
          label: '政协要闻',
          value: '2',
          navCode: '078'
        },
        {
          label: '人事任免',
          value: '4',
          navCode: '14'
        },
        {
          label: '报告讲话',
          value: '5',
          navCode: '29'
        },
        {
          label: '通知公告',
          value: '3',
          navCode: '110'
        },],
      value2: '1',
      list2: [
        {
          label: '委员履职',
          value: '1',
          navCode: '6'
        }, {
          label: '提案信息',
          value: '2',
          navCode: '33'
        },
        {
          label: '社情民意',
          value: '3',
          navCode: '34'
        },
      ],
      value3: '1',
      list3: [
        {
          label: '政协党建',
          value: '1',
          navCode: '103'
        }, {
          label: '政协工作',
          value: '2',
          navCode: '101'
        }
      ],
      value4: '1',
      list4: [
        {
          label: '视察调研',
          value: '1',
          navCode: '106'
        }, {
          label: '会议活动',
          value: '2',
          navCode: '9'
        }
      ],
      active1: '1',
      active1List: [{
        label: '机关建设', value: '1', navCode: '5'
      }, {
        label: '党派团体', value: '2', navCode: '100'
      }],
      active2: '1',
      active2List: [{
        label: '政协论坛', value: '1', navCode: '10'
      }, {
        label: '专题荟萃', value: '2', navCode: '31'
      }],
      dataObj: {
        titleObj: {},
        zxdjImg: [],
        zxgzImg: [],
        scdyImg: [],
        hdhyImg: [],
        xqzxImg: [],
        imgList1: []
      },
      areaCode: global.areaCode,
      navigationList: [
        { label: '全自治区', value: '65' },
        { label: '‌乌鲁木齐市‌', value: '6501' },
        { label: '伊犁州', value: '6540' },
        { label: '昌吉州‌', value: '6523' },
        { label: '阿克苏地区‌', value: '6529' },
        { label: '巴州‌', value: '6528' },
        { label: '喀什地区‌', value: '6531' },
        { label: '克拉玛依', value: '6502' },
        { label: '哈密市‌', value: '6505' },
        { label: '塔城地区‌', value: '6542' },
        { label: '吐鲁番市‌', value: '6504' },
        { label: '和田地区‌', value: '6532' },
        { label: '博州‌', value: '6527' },
        { label: '阿勒泰地区‌', value: '6543' },
        { label: '克州‌', value: '6530' },
      ],

    }
  },
  components: {
    footerBox,
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.getData()
  },
  methods: {
    constructFn() {
      this.$message.warning('建设中！')
    },
    // 导航点击
    navigationClick(item) {
      this.areaCode = item.value
      this.getNews()
    },
    loginFn() {
      const obj = {
        username: global.username,
        password: global.password
      }
      login(obj)
        .then((res) => {
          if (res.status === 200) {
            sessionStorage.setItem('token', res.data.token)
            sessionStorage.setItem('expires', res.data.expires)
            sessionStorage.setItem('lastAccessTime', res.data.lastAccessTime)
            this.getData()
          }
        })
        .catch(() => { })
    },
    repSearch() {
      this.$router.push({
        path: '/representative',
        query: {
          searchKey: this.repName,
          type: 'search'
        }
      })
    },
    getNews() {
      // 图片新闻
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '078',
        size: 5,
        type: '01',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.tpxw = res.data.content
      })
      // 综合新闻
      articlePage({
        areaCode: this.areaCode,
        navigationCode: 'cppccwz-016',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.zhxw = res.data.content
      })
      // 政协要闻
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '078',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.zxyw = res.data.content
          this.dataObj.titleObj = res.data.content[0]
        }
      })
      // 通知公告
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '110',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.tzgg = res.data.content
        }
      })
      // 人事任免
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '14',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.rsrm = res.data.content
        }
      })
      // 报告讲话
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '29',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.bgjh = res.data.content
        }
      })
      // 机关建设
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '5',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.jgjs = res.data.content
        }
      })
      // 党派团体
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '100',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.dptt = res.data.content
        }
      })
      // 政协论坛
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '10',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.zxlt = res.data.content
        }
      })
      // 专题荟萃
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '31',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.zthc = res.data.content
        }
      })
      // 委员履职
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '6',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.wylz = res.data.content
        }
      })
      // 提案信息
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '33',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.taxx = res.data.content
        }
      })

      // 社情民意
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '34',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.sqmy = res.data.content
        }
      })
      // 会议活动
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '9',
        size: 6,
        type: '02',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.hdhy = res.data.content
        }
      })
      //会议活动图片新闻
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '9',
        size: 1,
        type: '01',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.hdhyImg = res.data.content
      })
      // 政协党建图片新闻
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '103',
        size: 1,
        type: '01',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.zxdjImg = res.data.content
      })
      // 政协党建
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '103',
        size: 5,
        type: '02',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.zxdj = res.data.content
      })
      // 政协工作图片新闻
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '101',
        size: 1,
        type: '01',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.zxgzImg = res.data.content
      })
      // 政协工作
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '101',
        size: 6,
        type: '02',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.zxgz = res.data.content
      })
      // 学习培训
      articlePage({
        areaCode: this.areaCode,
        navigationCode: 'cppccwz-015',
        size: 6,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.data.content.length) {
          this.dataObj.xxpx = res.data.content
        }
      })
      //视察调研图片新闻
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '106',
        size: 1,
        type: '01',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.scdyImg = res.data.content
      })
      // 视察调研
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '106',
        size: 5,
        type: '02',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.scdy = res.data.content
      })
      // 委员讲堂图片新闻
      articlePage({
        areaCode: this.areaCode,
        navigationCode: 'zx_wyjt',
        size: 1,
        sort: 'publishTime,desc',
        type: '01',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.xqzxImg = res.data.content
      })
      // 委员讲堂
      articlePage({
        areaCode: this.areaCode,
        navigationCode: 'zx_wyjt',
        size: 6,
        sort: 'publishTime,desc',
        type: '02',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.xqzx = res.data.content
      })
      articlePage({
        areaCode: this.areaCode,
        navigationCode: '6,33,34',
        size: 1,
        type: '01',
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.imgList1 = res.data.content
      })
      // 视频
      articlePage({
        areaCode: this.areaCode,
        navigationCode: 'video',
        type: '01',
        size: 20,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.videoList = res.data.content
      })
      // 书籍推荐
      articlePage({
        areaCode: this.areaCode,
        navigationCode: 'book',
        type: '01',
        size: 5,
        sort: 'publishTime,desc',
        tenantCode: global.tenantCode
      }).then(res => {
        this.dataObj.bookList = res.data.content
      })
    },
    getData() {
      const that = this
      if (!this.$common.isToken()) {
        this.loginFn()
        return
      }
      this.getDictionary()
      this.getNews()

      // 获取主席
      representativeSearch({
        type: '01',
        isGroup: '01',
        isZhuXi: '01',
        zhuXiRank: 1,
        tenantUUID: global.tenantCode,
        sort: 'sortNo,desc'
      }).then(res => {
        if (res.data.length) {
          this.leaderObj.zhuxi = res.data[0]
        }
      })
      //  副主席
      representativeSearch({
        type: '01',
        isGroup: '01',
        isZhuXi: '01',
        zhuXiRank: 2,
        tenantUUID: global.tenantCode,
        sort: 'sortNo,desc'
      }).then(res => {
        if (res.data.length) {
          const arr = res.data
          for (let i = 0; i < res.data.length; i++) {
            arr[i].zhuXiSort = arr[i].extend.zhuXiSort
          }
          this.leaderObj.fuzhuxi = this.$common.listSort(arr, 'zhuXiSort', 2)
        }
      })
      //  秘书长
      representativeSearch({
        type: '01',
        isGroup: '01',
        secretaryGeneral: '01',
        tenantUUID: global.tenantCode,
        sort: 'sortNo,desc'
      }).then(res => {
        if (res.data.length) {
          this.leaderObj.mishuzhang = res.data[0]
        }
      })
      // 获取友情链接
      friendlyLinksSearch({
        sort: 'sortNo,asc',
        size: 9999,
        tenantCode: global.tenantCode
      }).then(res => {
        if (res.status === 200) {
          that.$refs.footerBox.dataFn(res.data)
        }
      })
    },

    // 查询字典数据
    getDictionary() {
      const type = 'friendlyLinksList'
      dictionarySearch({ type: type, tenantCode: global.tenantCode }).then(res => {
        if (res.status === 200) {
          this.dictionarys = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
$boxwidth: 1200px;

.suspension1 {
  position: fixed;
  width: 140px;
  background-color: #fff;
  left: 10px;
  top: 400px;
  border-radius: 10px;
  box-shadow: 0 0px 10px 1px rgba(99, 99, 99, 0.5);
  padding: 5px;
  overflow: hidden;
  text-align: center;
  font-size: 14px;
}

.suspension2 {
  position: fixed;
  width: 100px;
  right: 10px;
  top: 350px;
  border-radius: 10px;
}

.suspension3 {
  position: fixed;
  width: 140px;
  background-color: #fff;
  right: 10px;
  top: 550px;
  border-radius: 10px;
  box-shadow: 0 0px 10px 1px rgba(99, 99, 99, 0.5);
  padding: 5px;
  overflow: hidden;
  text-align: center;
  font-size: 14px;
}

.homePage {
  width: $boxwidth;
  margin: auto;

  .navigationList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    width: calc(100% - 40px);
    margin: auto;
    padding: 10px 20px 5px 20px;
    margin-bottom: 15px;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 0 8px 3px rgba(66, 66, 66, 0.3);

    /* 四周阴影 */
    .navigationItem {
      cursor: pointer;
      position: relative;
      height: 36px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .navigationAvtive {
        position: absolute;
        bottom: 2px;
        width: 50px;
        height: 5px;
        border-radius: 5px;
      }
    }

    .navigationItem:hover {
      opacity: 0.7;
    }
  }

  // 滚动播报
  .broadcastBox {
    display: flex;
    align-items: center;
    width: 100%;
    background-color: #e9f1ff;
    padding: 10px 0;

    .broadcast-left {
      width: 70px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 600;
      flex-direction: column;
    }

    .broadcast-vertical {
      width: 1px;
      height: 36px;
      margin-right: 10px;
    }

    .broadcast-right {
      width: calc(100% - 80px);
      padding: 0 10px;
      display: flex;
      align-items: center;
      height: 100%;

      i {
        margin: 0 15px 0 5px;
      }

      .seamless-warp {
        width: calc(100% - 20px);
        overflow: hidden;

        .broadcast-list {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;


          .broadcast-item {
            white-space: nowrap;
            margin-right: 20px;

            a:hover {
              text-decoration: underline;
            }
          }
        }
      }

    }
  }


  .item-box {
    display: flex;
    width: $boxwidth;
    margin-bottom: 10px;
    justify-content: space-between;

    .itemHeaderOne {
      display: inline-block;
      padding: 10px 10px;
      font-size: 20px;
      color: #fff;
      font-weight: 600;
      width: 100%;
      text-align: center;
    }

    .hdjl-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      padding: 0px 10px;
      padding-top: 15px;
      margin-bottom: -15px;

      .hdjl-content-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 47%;
        background: #e9f5ff;
        padding: 25px 10px;
        margin-bottom: 25px;
        border-radius: 10px;
        font-size: 18px;
        cursor: pointer;

        .hdjl-i-t {
          padding-top: 10px;
        }
      }

      .hdjl-content-item:hover {
        opacity: 0.6;
      }
    }

    // 书籍推荐
    .bookListBox {
      display: flex;
      padding: 30px 0;
      min-height: 200px;

      .book_item {
        width: 33%;

        img {
          width: 200px;
          height: 300px;
          object-fit: cover;
          display: block;
          margin: auto;
        }

        .book_item_title {
          width: 100%;
          text-align: center;
          padding-top: 20px;
        }
      }
    }

    .img_border {
      border: 3px solid #c2d0e9;
      border-radius: 4px;
      padding: 4px;
      background-color: #fff;
    }

    .hyshgzClass {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 286px;

      img {
        display: block;
      }

      .hyshgz_title {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 2;
        background-color: #00000050;
        color: #fff;
        width: 100%;
        padding: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .zrzc-content {
      padding-top: 10px;
      padding-left: 10px;

      .rep-box {
        display: flex;
        padding-top: 20px;

        .rep-photo {
          width: 100px;
          height: 120px;
          overflow: hidden;

          img {
            width: 100%;
            object-fit: cover;
          }
        }

        .rep-msg {
          width: calc(100% - 100px);
          box-sizing: border-box;

          .rep-name {
            padding-bottom: 20px;
            font-size: 18px;

            .r-n {
              font-weight: 600;
            }
          }

          .rep-c {
            padding-top: 20px;
            border-top: 1px solid #f0f0f0;
            color: #6e6d6d;
          }
        }
      }

      .personnel {
        display: flex;
        line-height: 36px;
        font-size: 18px;

        .personnel-l {
          font-weight: 600;
          width: 96px;
        }

        .personnel-list {
          width: calc(100% - 106px);

          .personnel-n {
            color: #6e6d6d;
            padding-right: 10px;
            white-space: nowrap;
          }
        }
      }
    }

    // 机关党建
    .jgdj_left {
      display: flex;
      justify-content: space-between;
      padding: 15px 0;

      .jgdj_left_img {
        object-fit: cover;
      }

      .jgdj_left_noImg {
        width: 300px;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #f0f0f0;

        img {
          width: 30%;
        }
      }

      .jgdj_left_box {

        .jgdj_left_title {
          font-size: 18px;
          width: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .jgdj_left_content {
          color: #737272;
          font-size: 14px;
          margin-top: 20px;
          width: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 23px;
        }
      }
    }

    // 头部标题
    .headline {
      width: 100%;
      padding: 15px;
      // background-color: #fff;
      display: flex;
      align-items: center;
      cursor: pointer;

      .headline-title {
        display: block;
        width: 100%;
        text-align: center;
      }
    }

    // 列表公用
    .item-list {
      display: flex;
      justify-content: space-between;

      .bd {
        padding-top: 8px;
        width: 100%;

        .bd-item {
          display: flex;
          align-items: center;
          height: 36px;
          justify-content: space-between;
          cursor: pointer;
          box-sizing: border-box;
          width: 100%;

          .bd-item-title {
            display: block;
            width: calc(100% - 100px);
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;

            i {
              padding-right: 5px;
            }
          }

          .bd-item-date {
            color: #999;
            font-size: 14px;
          }
        }
      }
    }

    .item-m {
      padding: 10px 15px;
      box-sizing: border-box;
      background: #fff;
    }

    .item-hd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      border-bottom: 2px solid #f0f0f0;

      .itemLabel {
        display: flex;
        align-items: center;
        color: #6e6d6d;
        height: 100%;
        position: relative;
        padding: 0 6px;

        .item-hd-text {
          font-size: 20px;
          font-weight: 600;
        }

        .item-hd-text-btm {
          position: absolute;
          width: 100%;
          left: 0;
          bottom: -2px;
          height: 2px;

        }
      }



    }

    .hd {
      display: flex;
      align-items: center;
      border-bottom: 2px solid #f0f0f0;
      height: 40px;

      .defaultColor {
        color: #9c9c9c;
      }

      .hd-item {
        font-size: 20px;
        cursor: pointer;
        margin-right: 30px;
        font-weight: 600;
        display: flex;
        align-items: center;
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 6px;

        .hd_item_borderBottom {
          position: absolute;
          width: 100%;
          height: 2px;
          bottom: -2px;
          left: 0;
          background: #ccc;
        }
      }
    }

    .matrixBox {

      .matrixBox-c {
        width: 100%;
        margin: auto;
        min-height: 200px;
      }

      .matrixBox_ul {
        display: flex;
        align-items: center;
        height: 100%;
        padding-left: 10px;
        width: 90%;
        margin: auto;

        .matrixBox_li {
          height: 100%;
          width: calc(33.33% - 10px);
          background-color: rgb(182, 77, 58);
          margin-right: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 18px;
        }
      }

    }

    // 视频
    .videoBox {
      .videoBox-c {
        width: 95%;
        margin: auto;
        min-height: 200px;
      }

      .carousel {
        cursor: pointer;
      }

      ::v-deep(.el-carousel) {
        .el-carousel__indicators {
          display: none;
        }

        .el-carousel__container {
          height: 320px;

          .carousel-img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }

          .carousel-title-item {
            border-radius: 0 0 10px 10px;
          }
        }

      }

      .carousel-img {
        object-fit: cover;
      }

      .carousel-title-item {
        position: absolute;
        bottom: 0px;
        color: #fff;
        text-align: center;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background-color: #0000006b;
        letter-spacing: 1px;
        padding: 10px;
      }
    }

    // 轮播图
    .imgNew {
      background: #fff;
      height: 310px;

      .carousel {
        cursor: pointer;
      }

      ::v-deep(.el-carousel) {
        height: 100%;

        .carousel-img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .carousel-title {
          position: absolute;
          left: 0;
          bottom: 0;
          height: 37px;
          width: 100%;
          line-height: 37px;
          background-color: rgba(7, 7, 10, 0.5);

          .carousel-title-item {
            width: 60%;
            color: white;
            font-size: 14px;
            text-indent: 1rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .el-carousel__container {
          height: 100% !important;
        }

        .el-carousel__indicators {
          position: absolute !important;
          bottom: 0;
          left: unset;
          right: 3% !important;
          transform: none !important;
          display: flex;
          align-items: center;

          li {
            button {
              width: 13px;
              height: 13px;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }
}
</style>
